module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Women Silver + Blush Open.12110a2c.png";